import React from 'react';
import { connect } from "react-redux";
import createItem from './../../../../API/Provider/CreateCountry'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../../Global/loader'
import { Form, Col, Row, Button } from 'react-bootstrap';
import { withNamespaces } from 'react-i18next';

class CreateDrzava extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: false,
        country_name: "",
        country_alpha2_code: "",
        country_alpha3_code: "",
        country_un_code: "",
        fiscalize: true
    }

    componentDidMount = async () => {
        document.title = this.props.t("Country") + "-" + this.props.t("Create")
 
         await this.setState({
             loading: false            
         })
    }

    handleChange(e){
        let value = e.target.value
        this.setState({
            [e.target.id]: value === "on" ? !this.state[e.target.id] : value
        })
    }

    submitCreate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let createPP = await createItem(
            this.state
        )

        if(createPP.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: "Creating was successful",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t(createPP.data.message),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>          
                        <Col sm={12} lg={6} xl={4}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2" md="4" htmlFor="client_type">{t('Name')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Control       
                                        id="country_name"                          
                                        type="text"
                                        value={this.state.country_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                 </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2" md="4" htmlFor="country_alpha2_code">{t('Alpha 2')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Control      
                                            id="country_alpha2_code"                          
                                            type="text"
                                            value={this.state.country_alpha2_code}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2" md="4" htmlFor="country_alpha3_code">{t('Alpha 3')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Control      
                                        id="country_alpha3_code"                          
                                        type="text"
                                        value={this.state.country_alpha3_code}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2" md="4" htmlFor="country_un_code">{t('UN code')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Control
                                        id="country_un_code"
                                        type="text"
                                        value={this.state.country_un_code}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2" md="4" htmlFor="fiscalize">{t('Fiscalize')}</Form.Label>
                                <Col sm="10" md="8">
                                    <Form.Label className="checbox-form-label" htmlFor="gridCheck2">
                                       <input    
                                            id="fiscalize"                       
                                            type="checkbox"
                                            checked={this.state.fiscalize}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </Form.Label>
                                </Col>
                            </Form.Group>

                            <div className="mb-3 text-center">
                                <Button                                     
                                    className="btnSpremi"
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </div>
                        </Col>
                    </Row>           
                    
                    <Row className="back-button-container">
                        <Button 
                            variant='default'
                            className="btn-default mt-2 mb-2"
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        </Button>
                    </Row>
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateDrzava));


